import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';

import "./categories.css";

export const Categories = ({data, isActive}) => {

    const ref = useRef();

    useLayoutEffect(() => {
        const refAnimate = ref.current.getBoundingClientRect().bottom;
        const onScroll = () => {
            if (refAnimate < window.scrollY) {
                ref.current.style.background = 'inherit';
                ref.current.style.position = 'fixed';
                ref.current.style.top = 0;
                ref.current.style.left = 0;
                ref.current.style.right = 0;
                ref.current.style.margin = "0!important";
                ref.current.style.zIndex = 10;
                ref.current.children[0].classList.add('container')
                
            } else {
                ref.current.style.position = 'relative';
            }
        }
        window.addEventListener('scroll', onScroll);
        return  () => window.removeEventListener("scroll", onScroll);
    })

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        data.then(data => setCategories(data));
    }, [data]);
    const handleClick = (id) => {
        const target = document.getElementById(`category-${id}`);
        target.scrollIntoView({block: 'center', behavior: 'smooth'});
    }


    const result = categories.map(item => (
        <div key={item.id} id={`nav-category-${item.id}`} onClick={() => handleClick(item.id)} className={`category-item ${isActive?.id === item.id ? 'active' : null}`}>
            <div className="category-content">
                {item.name}
            </div>
        </div>
    ));

    return (
        <div ref={ref} className="pt-2 pb-2">
            <div className="categories-list">
                {result}
            </div>
        </div>
    )
}
